import { useEffect, useState } from "react";
import { Attribute, Stars } from "../../../models/shared";
import { _, _c } from "../../../services/text-services";
import { ProductResponse } from "../../details/models/detail-page";
// @ts-ignore 
import styles from "./more-info.component.module.scss";

interface MoreInfoProps {
  data?: ProductResponse;
  sectionTitle?: string;
  about?: string;
  title: string;
  enTitle?: string;
  description?: string;
}

function MoreInfo({
  data,
  sectionTitle,
  about,
  title,
  enTitle,
  description = ""
}: MoreInfoProps) {
  if (!data && !description) return null;
  const [toggle, setToggle] = useState(false);
  const preTitle = data?.attributes ? (data.attributes as Attribute[])?.[0]?.value : "";

  return (
    <div className={_c(styles, "wrapper-info")}>
      {sectionTitle && (
        <div
          className={_c(styles, "section-title d-flex justify-content-around")}
        >
          <div className={_c(styles, "line")}></div>
          <h2>{_(sectionTitle)}</h2>
          <div className={_c(styles, "line")}></div>
        </div>
      )}
      <div>
        <h2 className={_c(styles, "title-id mb-3")}>
          {about && <span>{about + " "}</span>}
          {preTitle}
          {_(title) + " "}
          {enTitle && <span>{enTitle + " "}</span>}
        </h2>
        <div
          className={_c(
            styles,
            (toggle ? "more " : "read-more ") +
              " description-container-id d-flex flex-column"
          )}
        >
          <p className={_c(styles, "description-id")}>{_(description)}</p>
          {description.length > 400 && (
            <div
              className={_c(
                styles,
                (toggle ? "no-background" : "gradient-mode") + " layer-id"
              )}
            ></div>
          )}
        </div>
        {description.length > 400 && (
          <div
            className={_c(
              styles,
              "more-wrapper-id d-flex justify-content-center mt-3"
            )}
          >
            {toggle ? (
              <div
                onClick={() => setToggle(t => !t)}
                className={_c(styles, "more")}
              >
                <div className={_c(styles, "less-id")}></div>
              </div>
            ) : (
              <div
                onClick={() => setToggle(t => !t)}
                className={_c(styles, "more")}
              >
                <div className={_c(styles, "more-id")}></div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default MoreInfo;
